import { trackCustomerIOEvent } from "@/services/customerio";
import usePostHog from "@/services/posthog/hooks/usePostHog";

export const useTracker = () => {
  const { registerPostHog } = usePostHog();

  const track = (eventName: string, options?: Record<string, unknown>) => {
    registerPostHog(eventName, options);
    trackCustomerIOEvent(eventName, options);
  };

  return { track };
};

export default useTracker;
